import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import AuthModal from "./components/AuthModal";

import Home from "./pages/Home";
import StartHere from "./pages/StartHere";
import TopicsList, { TopicDetail } from "./pages/Topics";
import Branches, { BranchDetail } from "./pages/Branches";
import Compare from "./pages/Compare";
import FAQ from "./pages/FAQ";
import Dashboard from "./pages/Dashboard";
import AuthCallback from "./pages/AuthCallback";
import CareerDeepDive from "./pages/CareerDeepDive";
import DeepDiveSuccess from "./pages/DeepDiveSuccess";
import DeepDiveReport from "./pages/DeepDiveReport";
import Quiz from "./pages/Quiz";
import Donate from "./pages/Donate";

function AppShell() {
  const location = useLocation();
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  // Send a page_view to Google Analytics on every React Router navigation
  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);

  const openAuth = (mode = "login") => {
    setAuthMode(mode);
    setAuthOpen(true);
  };

  // OAuth callback handler — synchronous URL fragment check
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar onOpenAuth={openAuth} />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home onOpenAuth={openAuth} />} />
          <Route path="/start-here" element={<StartHere />} />
          <Route path="/topics" element={<TopicsList />} />
          <Route path="/topics/:slug" element={<TopicDetail />} />
          <Route path="/branches" element={<Branches />} />
          <Route path="/branches/:slug" element={<BranchDetail />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/career-deepdive" element={<CareerDeepDive onOpenAuth={openAuth} />} />
          <Route path="/career-deepdive/success" element={<DeepDiveSuccess />} />
          <Route path="/career-deepdive/reports/:id" element={<DeepDiveReport />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="*" element={<Home onOpenAuth={openAuth} />} />
        </Routes>
      </div>
      <Footer />
      <Chatbot />
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} mode={authMode} />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </AuthProvider>
  );
}
